import { QuizItem } from '../../../types/quiz';
/**
 * Randomly picks count items from an initial list.
 * @param {Array} sourceArray - An array of incoming items.
 * @param {number} count - The max number of items in a returned list.
 * @returns {Array} - List of randomly picked from an initial list items.
 */
export const getRandomVideos = (sourceArray: any[], count: number) => {
  if (sourceArray.length <= count) {
    return sourceArray;
  }

  const videosList = [];
  const initArr = [...sourceArray];

  // Create a randomized list of videos
  while (videosList.length < count) {
    const randomIndex = Math.floor(Math.random() * initArr.length); // NOSONAR
    const pikedItem = initArr.splice(randomIndex, 1)[0];

    videosList.push(pikedItem);
  }

  return videosList;
};

/**
 * Formats video duration.
 * @param {number} duration - Duration of the video in seconds.
 * @returns {string} - Formatted duration of the video.
 */
export const getFormattedDuration = (duration: number) => {
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;

  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

/**
 * Returns a number of "loggedOut" quizzes.
 * @param {QuizItem[]} items - Question items.
 * @returns {number} - Number of questions which contain fields loggedOut with value "true".
 */
export const getLoggedOutCount = (items: QuizItem[]) => {
  return items.filter((item) => item?.data?.loggedOut === 'true').length;
};
